import { ScrollableBody } from '../../Layout/ScrollableBody/ScrollableBody';
import { Heading } from '../../../controls/Heading/Heading';
import { CTAButton } from '../../../controls/ButtonBase';
import { useLocalization } from '../../../context/Localization/localization';
import { GMButtonGroup } from '../../../controls/ButtonGroup';
import { GMRoundedIcon, GMSizedIcon } from '../../../controls/Icon';

export interface ValuationExclusiveProps {
    onReviewEquity: (review: boolean) => void;
    onSkip?: () => void;
}

export const ValuationExclusive = (props: ValuationExclusiveProps) => {
    const Localization = useLocalization();

    return (
        <ScrollableBody
            heading={
                <Heading
                    primaryHeading={Localization.VehicleEquityDetected}
                    secondaryHeading={Localization.VehicleInDemand}
                    hint={Localization.ReviewEquity}
                    roundedIcon={
                        <GMRoundedIcon roundedBackgroundSize={'large'} themeType={'secondary'}>
                            <GMSizedIcon
                                iconType={'Equity'}
                                iconSize={'extraLarge'}
                                ariaLabel={Localization.EquityIcon}
                            />
                        </GMRoundedIcon>
                    }
                    showMustache
                />
            }
            proceedButtons={
                <GMButtonGroup
                    alignment={'center'}
                    buttons={[
                        (
                            <CTAButton
                                styleType={'primary'}
                                onClick={() => props.onReviewEquity(true)}
                                label={Localization.YesIWould}
                                kioskOptions={{ square: true }}
                                id={Localization.YesIWould}
                                ariaLabel={Localization.YesIWould}
                            />
                        ),
                        (
                            <CTAButton
                                styleType={'secondary'}
                                onClick={() => props.onReviewEquity(false)}
                                label={Localization.NoIWouldNot}
                                kioskOptions={{
                                    square: true,
                                    squareOptions: {
                                        roundedIcon: (
                                            <GMRoundedIcon
                                                themeType={'primary'}
                                                allowInvertedPrimary
                                                roundedBackgroundSize={'large'}
                                            >
                                                <GMSizedIcon iconSize={'custom'} iconType={'No'} />
                                            </GMRoundedIcon>
                                        ),
                                    },
                                }}
                                id={Localization.NoIWouldNot}
                                ariaLabel={Localization.NoIWouldNot}
                            />
                        ),
                    ]}
                />
            }
            unsetButtons
        />
    );
};